export default __webpack_public_path__ + "static/media/4.02cc07b7.png";